import { formatDistanceToNowStrict } from 'date-fns';
// @mui
import { Avatar, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import Image from '../../../components/Image';
import Spinner from '../../../components/Spinner';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(3),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 320,
  padding: theme.spacing(1.5),
  marginTop: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.neutral,
}));

const InfoStyle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(0.75),
  color: theme.palette.text.secondary,
}));

// ----------------------------------------------------------------------

// ChatMessageItem.propTypes = {
//   message: PropTypes.object.isRequired,
//   conversation: PropTypes.object.isRequired,
//   onOpenLightbox: PropTypes.func,
// };

export default function ChatMessageItem({ message, conversation, onOpenLightbox, currentUser }) {
  const sender = conversation.participants.find((participant) => participant.id === message.from_id);
  const senderDetails =
    message.from_id === currentUser.id
      ? { type: 'me' }
      : { avatar: sender?.userImage, name: sender?.name };

  const isMe = senderDetails.type === 'me';
  const isImage = message.contentType === 'photo';
  const firstName = senderDetails.name && senderDetails.name.split(' ')[0];

  const isLoading = message.text === "%LOADING%";

  return (
    <RootStyle>
      <Box
        sx={{
          display: 'flex',
          ...(isMe && {
            ml: 'auto',
          }),
        }}
      >
        {senderDetails.type !== 'me' && (
          <Avatar alt={senderDetails.name} src={senderDetails.userImage} sx={{ width: 32, height: 32, mr: 2 }} />
        )}

        {isLoading && <Spinner size={32} sx={{ pt: 3, width: 32, height: 32, position: 'absolute' }} />}

        <div>
          <InfoStyle
            variant="caption"
            sx={{
              ...(isMe && { justifyContent: 'flex-end' }),
            }}
          >
            {!isMe && `${firstName},`}&nbsp;
            {formatDistanceToNowStrict(new Date(message.time), {
              addSuffix: true,
            })}
          </InfoStyle>
          <ContentStyle
            sx={{
              ...(isMe && { color: 'grey.800', bgcolor: 'primary.lighter' }),
              ...(isImage && { p: 0 }),
            }}
          >
            {isImage ? (
              <Image
                alt="attachment"
                src={message.content}
                onClick={() => onOpenLightbox(message.content)}
                sx={{ borderRadius: 1, cursor: 'pointer', '&:hover': { opacity: 0.8 } }}
              />
            ) : (
              <Typography variant="body2">{isLoading ? "Loading Response..." : message.text}</Typography>
            )}
          </ContentStyle>

        </div>
      </Box>
    </RootStyle>
  );
}
